module.exports = __webpack_public_path__ + "static/media/shield-check.74c9ec13.svg";